window.initMap = () => {
    const {google} = window;
    const mapElement = document.querySelector('.js-company-map');
    const office = {lat: 50.1851038, lng: 8.466879};
    const map = new google.maps.Map(mapElement, {zoom: 15, center: office});
    // eslint-disable-next-line no-new
    new google.maps.Marker({position: office, map});
};
